/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Export_Usage_Dates_Hint_DaysInputs */



/**
* | output |
* | --- |
* | "Usage on these days, both included." |
*
* @param {Admin_Export_Usage_Dates_Hint_DaysInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_usage_dates_hint_days = /** @type {((inputs?: Admin_Export_Usage_Dates_Hint_DaysInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Usage_Dates_Hint_DaysInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzung an diesen Tagen, beide eingeschlossen.")
	return /** @type {LocalizedString} */ ("Usage on these days, both included.")
});